<template>
  <div class="home">
<div class="works">
<div class="works-ban">
		<h2>新聞中心</h2>
		<p>主頁 / 新聞中心</p>
	
	</div>
	<div class="home-ct">
<div class="wok-con">
	<div class="blur">
				<h3>{{data.title}}</h3>
				<div class="aut">
					<span>————  By {{data.author}} on {{data.dtTime}}</span>
				</div>
				<p v-html="data.content"></p>
			</div>

 
 </div>

		</div>
</div>
  
    </div>
</template>
<script>


export default {

  data() {
    return {
	id:'',
    data:'',
	channel_id:0
    };
  }, 
 mounted() {
	 
this.id = this.$route.query.id;
		this.sandMate();
		this.sandCase();
		},methods: {
		 scroll(scrollData){
		                console.log(scrollData)
		            },
			        switchCol(col){
			            this.col = col
			            console.log(this.col)
			      },
			      loadmore(index){
			            this.data = this.data.concat(this.data)
			      },

			sandMate(){
			
			this.$axios({
			  method: "post",
			  url: "service.php?action=index_newsDetail",
			  data: {id:this.id},  
			}).then((res) => {
				let data=res.data;
						
				if(data.code==1){
						
					this.data=data.data;
					this.channel_id=data.data.channel_id
					let content = this.data.content
					const regex = new RegExp('<img', 'gi')
					const reges = new RegExp('type="video/x-ms-asf-plugin" width="550" height="400" autostart="false" loop="true" />', 'gi')
					this.data.content = content.replace(regex, `<img style="max-width: 100%; height: auto;margin-bottom:20px"`)
					this.data.content=this.data.content.replace(/\<embed/gi, '<video width="700" height="470" controls controlslist="nodownload"><source')
					this.data.content=this.data.content.replace(reges, 'type="video/mp4"></video>')
				
					
				}
			 
			});
			
			
			
			},sandCase(){
				this.$axios({
				  method: "post",
				  url: "/api/noticelist",
				  data: {page:1},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==200){
						
						this.notice=data.data;
						
						
					
					}
				 
				});
			},buff(item){
				this.channel_id=item
				this.sandMate()
			}
		}
};
</script>
<style lang="scss" scoped>

.works{
	.wok-con{
		margin-top: 30px;
		.l1{
			line-height: 40px;
		}
		.l2{
			color: #8E8D8D;
		}
	
		.pic{
			width: 100%;
		}
		
		.blur{
			width: 700px;
			margin: 0 auto;
			h3{
				font-size: 26px;
				font-weight: normal;
				text-transform: uppercase
			}
			.aut{
				line-height: 60px;
				font-size: 14px;
				span{
					margin-right: 20px;
				
				}
			}
		}
		
		.con-buff{
			margin-top: 30px;
			.tit{
				font-size: 24px;
				color: #0A0A0A;
				font-weight: bolder;
				line-height: 50px;
				border-bottom: 1px solid #EAEAEA;
			}
			.con{
				color: #5A5A5A;
				border-bottom: 1px solid #EAEAEA;
				padding: 20px 0;
			}
		}
		
	}


	.works-ban{
		padding-top: 30px;
		background: #0A0A0A;
		height: 107px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		h2{
			font-size: 43px;
		}
		span{
			margin: 20px;
			color: #B5B5B5;
		}
		.acts{
			color: #FFFFFF;
			font-weight: bolder;
		}
		p{
			font-size: 18px;
		}
	}

}

</style>